import { Circle, Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function EyeIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12z" />
      <Circle cx="12" cy="12" r="3" />
    </LineIcon>
  );
}
